module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("HMP Isle of Wight – Parkhurst")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Clissold Road")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Newport")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltsa_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("My love,")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("When I think of the moments that have given me greatest pleasure: scaling an impossible rock face, watching the moon over the ocean on Christmas morning, the first time my dog saw snow - all of them pale beside the second I looked into your eyes and knew that you loved me.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("You come into this dismal place like a rainbow. Your colours glow, scaring away shadows, softening the cold, hard lines of my prison. Your presence changes everything.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("When I first came here, I thought no fate could be more cruel. How wrong I was. These bars are nothing. Being apart from you, living every moment of my day without you, is the torture that will break me.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I yearn for you.")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "lti_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Hamish")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "sptni"
  }, [_vm._v("PROPERTY OF AVON AND SOMERSET POLICE. Ref: 544/45.2 Hamish Wolfe.")]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltadd_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("HMP Isle of Wight – Parkhurst")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Clissold Road")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Newport")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltsa_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Maggie Rose")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("c/o Ellipsis Literary Agency")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bute Street")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("London WC3")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Monday, 2 November 2015")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltsa_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dear Miss Rose,")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I am not a killer.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I know the lawyer in you will be saying: evidence, give me evidence. And believe me, I can, lots of it. But for now, I make one simple appeal to the seeker of truth that I know you to be. I am an innocent man. Please help me.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sincerely yours,")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "lti_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Hamish Wolfe")])]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltadd_1"
  }, [_vm._v("Anne Louise Moorcroft")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd_1"
  }, [_vm._v("Ellipsis Literary Agency")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd_1"
  }, [_vm._v("Bute Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd_1"
  }, [_vm._v("London WC3")]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt_1"
  }, [_vm._v("Mr Hamish Wolfe")]), _vm._v(" "), _c('p', {
    staticClass: "lt_1"
  }, [_vm._v("c/o HMP Isle of Wight")]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl_1"
  }, [_vm._v("18 November 2015")]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltsa_1"
  }, [_vm._v("Dear Mr Wolfe")]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltsa_1"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Re: Maggie Rose")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt_1"
  }, [_vm._v("My client regrets that her answer to you must remain the same. Her current projects will keep her entirely occupied for the foreseeable future and consequently she must decline, once again, your request that she consult regarding your case.")]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt_1"
  }, [_vm._v("She has asked that I refrain from forwarding any future correspondence from you. It would be better if you did not contact us again.")]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt_1"
  }, [_vm._v("Yours faithfully")]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt_1"
  }, [_vm._v("Anne Louise Moorcroft")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-229e5985","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 72
// module chunks = 0